module.exports = __webpack_public_path__ + "img/logo.393f552f.png";